import script from "./ContentEditorTest.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentEditorTest.vue?vue&type=script&setup=true&lang=js"

import "./ContentEditorTest.vue?vue&type=style&index=0&id=c46f5378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c46f5378"]])

export default __exports__